import { useState } from "react";
import { ArrowRight, Play } from "lucide-react";
import { Link } from "react-router-dom";

import { GridPattern } from "@/components/parceiros/GridPattern";

const VIDEO_ID = "lRz43alhxio";

const STATS = [
  { value: "10 anos", label: "de operação" },
  { value: "+60 mil", label: "clientes atendidos" },
  { value: "R$ 650M+", label: "captados" },
  { value: "100%", label: "adimplência" },
];

export const EventoEscritorio = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section
      id="quem-e-a-allu"
      className="relative overflow-hidden bg-[#FAF8F5] scroll-mt-24"
    >
      <GridPattern color="75, 208, 132" opacity={0.09} gap={64} />

      <div className="container-wide py-16 sm:py-24 relative">
        <div className="max-w-3xl mx-auto text-center mb-8 sm:mb-10">
          <div className="text-[11px] font-semibold tracking-[0.14em] uppercase text-zinc-500">
            Quem é a Allu
          </div>
          <h2
            className="mt-3 text-3xl sm:text-4xl md:text-5xl font-medium text-[#112711] leading-[1.1]"
            style={{
              fontFamily:
                '"Playfair Display", Georgia, "Times New Roman", serif',
              letterSpacing: "-0.02em",
            }}
          >
            Fundada em 2016, a Allu é a terceira maior empresa do mundo em seu
            segmento.
          </h2>
          <p className="mt-5 sm:mt-6 text-base sm:text-lg text-zinc-600 max-w-2xl mx-auto leading-relaxed">
            E agora vamos escolher alguns novos parceiros para quem vamos abrir
            a possibilidade de divulgação dos nossos produtos de investimento.
          </p>
        </div>

        <dl className="max-w-3xl mx-auto mb-8 sm:mb-10 grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4 md:gap-x-6 md:divide-x md:divide-zinc-200">
          {STATS.map((s, i) => (
            <div
              key={i}
              className={`text-center ${i > 0 ? "md:pl-4 lg:pl-6" : ""}`}
            >
              <dt
                className="text-2xl sm:text-3xl md:text-4xl font-medium text-[#112711] tabular-nums leading-none"
                style={{
                  fontFamily:
                    '"Playfair Display", Georgia, "Times New Roman", serif',
                  letterSpacing: "-0.02em",
                }}
              >
                {s.value}
              </dt>
              <dd className="mt-2 text-[10px] sm:text-[11px] uppercase tracking-wider text-zinc-500 leading-snug">
                {s.label}
              </dd>
            </div>
          ))}
        </dl>

        <div className="relative rounded-2xl overflow-hidden bg-zinc-900 aspect-video ring-1 ring-zinc-200 max-w-3xl mx-auto">
          {playing ? (
            <iframe
              src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0&modestbranding=1`}
              className="w-full h-full border-0"
              title="Allu — Por dentro da operação"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              className="group absolute inset-0 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#112711] focus-visible:ring-offset-2"
              aria-label="Reproduzir vídeo: Veja nossa estrutura — 56 segundos"
            >
              <img
                src={`https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                alt=""
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).src = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;
                }}
              />
              <div
                aria-hidden="true"
                className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors"
              />

              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 sm:gap-4 px-4">
                <div
                  className="w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center transition-all duration-200 group-hover:scale-110"
                  style={{ backgroundColor: "rgba(17, 39, 17, 0.9)" }}
                >
                  <Play
                    className="w-6 h-6 sm:w-7 sm:h-7 text-white fill-white ml-1"
                    aria-hidden="true"
                  />
                </div>
                <span className="text-white font-semibold text-base sm:text-lg tracking-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
                  Veja nossa estrutura
                </span>
              </div>

              <div className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4">
                <span className="inline-block bg-black/80 text-white text-[11px] sm:text-xs font-medium tabular-nums px-1.5 py-0.5 rounded">
                  0:56
                </span>
              </div>
            </button>
          )}
        </div>

        <div className="mt-10 sm:mt-12 flex justify-center">
          <Link
            to="/evento/aplicar"
            className="inline-flex items-center gap-2 rounded-full font-semibold text-sm h-12 px-7 bg-[#112711] hover:bg-[#1F4A33] text-white transition-all hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#112711]"
          >
            Tenho interesse em participar
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
